import { OTHER } from "../../../../consts";
import { OTHERS } from "./HospitalizationDetails";

export const FORM_KEYS = {
  intimated_by: "intimated_by",
  intimator_name: "intimator_name",
  relationship: "relationship",
  intimator_mobile_number: "",
  patient: "patient",
  alternate_mobile_number: "alternate_mobile_number",
  date_of_incidence: "date_of_incidence",
  time_of_incidence: "time_of_incidence",
  date_of_admission: "date_of_admission",
  time_of_admission: "time_of_admission",
  date_of_discharge: "date_of_discharge",
  time_of_discharge: "time_of_discharge",
  pincode: "pincode",
  state: "state",
  district: "district",
  mandal: "mandal",
  village: "village",
  hospital: "hospital",
  hospital_name: "hospital_name",
  hospital_city_and_pincode: "hospital_city_and_pincode",
  icu_days: "icu_days",
  non_icu_days: "non_icu_days",
  doctor_name: "doctor_name",
  doctor_mobile_number: "doctor_mobile_number",
  doctor_registration_number: "doctor_registration_number",
  reason_of_hospitalization: "reason_of_hospitalization",
  ailment: "ailment",
  description_of_diagnosis: "description_of_diagnosis",
  have_other_policies: "have_other_policies",
  policy_number: "policy_number",
  insurer_name: "insurer_name",
  sum_insured: "sum_insured",
  coverage_type: "coverage_type",
  policy_start_date: "policy_start_date",
  policy_end_date: "policy_end_date",
  attachment_type: "attachment_type",
  document_ids: "document_ids",
};

export const getAge = (dateString) => {
  if (dateString) {
    const [day, month, year] = dateString.split("-").map(Number);
    const birthDate = new Date(year, month - 1, day);
    const today = new Date();

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (days < 0) {
      months--;
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    return `${years} years ${months} months ${days} days`;
  } else return "--";
};

export const validFileTypes = [
  ".pdf",
  ".doc",
  ".docx",
  ".jpg",
  ".jpeg",
  ".png",
];
export const DESCRIPTION_OF_DIAGNOSIS_MAX_LENGTH = 500;

export const checkMandatoryFields = (formData, currentStep) => {
  let disableNextButton = false;
  if (currentStep === 1) {
    const intimatedBy = formData[FORM_KEYS.intimated_by];
    const isOther = formData[FORM_KEYS.intimated_by]?.value === OTHER;
    const intimatorName = formData[FORM_KEYS.intimator_name]?.trim();
    const relationship = formData[FORM_KEYS.relationship];
    const intimatorMobileNumber =
      formData[FORM_KEYS.intimator_mobile_number]?.trim();
    if (
      !intimatedBy ||
      (isOther &&
        (!intimatorName ||
          !relationship ||
          (intimatorMobileNumber && intimatorMobileNumber.length !== 10)))
    ) {
      disableNextButton = true;
    }
  } else if (currentStep === 2) {
    const patient = formData[FORM_KEYS.patient];
    const alternateMobileNumber =
      formData[FORM_KEYS.alternate_mobile_number]?.trim();

    if (
      !patient ||
      (alternateMobileNumber && alternateMobileNumber.length !== 10)
    ) {
      disableNextButton = true;
    }
  } else if (currentStep === 3) {
    const dateOfIncidence = formData[FORM_KEYS.date_of_incidence];
    const timeOfIncidence = formData[FORM_KEYS.time_of_incidence];
    const hospitalizationDetails = formData.hospitalizationDetails;
    if (!dateOfIncidence || !timeOfIncidence) {
      disableNextButton = true;
    } else {
      // check the each mandatory field for each hospital details
      hospitalizationDetails.map((details) => {
        const dateOfAdmission = details[FORM_KEYS.date_of_admission];
        const timeOfAdmission = details[FORM_KEYS.time_of_admission];
        const dateOfDischarge = details[FORM_KEYS.date_of_discharge];
        const timeOfDischarge = details[FORM_KEYS.time_of_discharge];
        const state = details[FORM_KEYS.state];
        const district = details[FORM_KEYS.district];
        const mandal = details[FORM_KEYS.mandal];
        const hospital = details[FORM_KEYS.hospital];
        const hospitalName = details[FORM_KEYS.hospital_name]?.trim();
        const doctorName = details[FORM_KEYS.doctor_name]?.trim();
        const reasonForHospitalization =
          details[FORM_KEYS.reason_of_hospitalization];
        const ailment = details[FORM_KEYS.ailment];
        const doctorMobileNumber =
          details[FORM_KEYS.doctor_mobile_number]?.trim();
        if (
          !dateOfAdmission ||
          !timeOfAdmission ||
          !state ||
          !district ||
          !mandal ||
          !hospital ||
          (hospital && hospital?.value === OTHERS && !hospitalName) ||
          !doctorName ||
          !reasonForHospitalization ||
          (!isMaternity(reasonForHospitalization?.label) && !ailment) ||
          (doctorMobileNumber && doctorMobileNumber.length != 10) ||(dateOfDischarge && !timeOfDischarge)
        ) {
          disableNextButton = true;
        }
      });
    }
  } else if (currentStep === 4) {
    const haveOtherPolicies = formData[FORM_KEYS.have_other_policies] === "Yes";
    const existingPolicyDetails = formData.existingPolicyDetails;
    if (haveOtherPolicies) {
      existingPolicyDetails.map((policy) => {
        const policyNumber = policy[FORM_KEYS.policy_number]?.trim();
        const insurerName = policy[FORM_KEYS.insurer_name]?.trim();
        const sumInsured = policy[FORM_KEYS.sum_insured]?.trim();
        const coverageType = policy[FORM_KEYS.coverage_type];
        const policyStartDate = policy[FORM_KEYS.policy_start_date];
        const policyEndDate = policy[FORM_KEYS.policy_end_date];

        if (
          !(
            policyNumber ||
            insurerName ||
            sumInsured ||
            coverageType ||
            policyStartDate ||
            policyEndDate
          )
        ) {
          disableNextButton = true;
        }
      });
    }
  } else if (currentStep === 5) {
    const documents = formData[FORM_KEYS.document_ids];
    documents.map((documentDetails) => {
      const docType = documentDetails.documentType;
      const docs = documentDetails.docs;
      if (docType && !docs.length) {
        disableNextButton = true;
      }
    });
  }
  return disableNextButton;
};

export const getPolicyMembers = (policyDetails) => {
  if (policyDetails) {
    return policyDetails?.member_details;
  } else return [];
};

export const getLocation = (policyDetails) => {
  let location = "";
  if (policyDetails.communication_village) {
    location += policyDetails.communication_village + ", ";
  }
  if (policyDetails.communication_mandal) {
    location += policyDetails.communication_mandal + ", ";
  }
  if (policyDetails.communication_district) {
    location += policyDetails.communication_district + ", ";
  }
  if (policyDetails.communication_state) {
    location += policyDetails.communication_state + ", ";
  }
  if (policyDetails.communication_pincode) {
    location += policyDetails.communication_pincode;
  }
  return location;
};
export const POLICY_STATUSES = {
  ACTIVE: "Active",
  IN_ACTIVE: "In-Active",
};
export const getHealthPolicyStatus = (status) => {
  if (status) {
    if (
      status == "true" ||
      String(status) === "true" ||
      String(status)?.toLowerCase === "active"
    ) {
      return POLICY_STATUSES.ACTIVE;
    } else {
      return POLICY_STATUSES.IN_ACTIVE;
    }
  }
  return null;
};

export const isMaternity = (hospitalizationReason) => {
  return (
    typeof hospitalizationReason === "string" &&
    hospitalizationReason.toLowerCase().includes("maternity")
  );
};
